import QuoteLeft from 'assets/images/quote-left.svg';

import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GTAG_ID: googleTagId,
  REACT_APP_GTAG_BUTTON_EVENT_ID: googleTagEventId,
} = process.env;

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const gtagEventId =
  googleTagId && googleTagEventId ? `${googleTagId}/${googleTagEventId}` : '';

const config = {
  groupId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Dentistry in Motion',
  tokenName: 'dentistryinmotionSubscriberToken',
  globalClass: 'dentistryinmotion-container',
  clientHeader,
  enableHeroButton: true,
  skipChoosePlan: true,
  pricingType: 'standard-pricing',
  couponProps: {
    enableApplyCouponBar: true,
  },
  headerProps: {
    enable: true,
  },
  homeTemplateProps: {
    heroSection: {
      variant: 3,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        scrollTo: 'pricing-benefit-section',
      },
      secondaryButton: 'Login',
      secondaryButtonProps: {
        to: '/login',
      },
      heroImage: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      variant: 8,
      heroImage: '/images/home-images/pricing-benefits.webp',
    },
    subscriptionSection: {
      priority: 'top',
      tabVariant: 1,
      renderAsTabsLimit: 4,
      carouselResponsiveItems: {
        desktop: 2,
      },
      plansPerRow: {
        lg: 2,
      },
      planCardProps: {
        buttonProps: {
          gtagEventId,
          normalVariant: 'contained',
          highlightedVariant: 'contained',
          customSpace: 12,
        },
      },
      enableContactSection: false,
    },
    patientContact: {
      patientPortalId: '40118398',
      patientFormId: 'd964d9a2-8c2e-4269-acc6-324c3dd2ab57',
    },
    howItWorksSection: {
      variant: 6,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.webp',
    },
    testimonialSection: {
      variant: 4,
      title: "Real People, Real Results",
      alignTitle: "center",
      itemsPerRow: 3,
    },
    staticHeroSection: {
      enable: true,
      enableStaticFooter: false,
      linkTo: '/employer',
      variant: 1,
    },
  },
  employer: {
    variant: 2,
    hubspotForm: {
      formId: '3568cefe-8c27-4e62-ac1e-1771d4baac5f',
      portalId: '40118398',
    },
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      showSubtitleDivider: true,
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        scrollTo: 'static-plan-cards',
        color: 'primary',
      },
      background: '/images/employer/employee-banner-img.webp',
    },
    benefitsSection: {
      variant: 1,
      columns: 3,
      customXS: 6,
      alignTitle: 'left',
      alignCard: 'left',
      sameLineIconText: 6,
    },
    metrics: {
      graphImg: '/images/employer/graph.webp',
    },
    subscriptionSection: {
      cardVariant: 5,
      tabVariant: 2,
      renderAsCardGrid: true,
      frequencyPlans: true,
      showOtherPlans: false,
      showPrimaryButton: true,
      offerText1Variant: 'body1',
      offerText2Link: '',
      offerText2Action: {
        type: 'popup',
        action: 'savings-summary',
      },
      gridModel: true,
      carouselResponsiveItems: {
        superLargeDesktop: 4,
        desktop: 2,
      },
      plansPerRow: {
        lg: 4,
      },
      showAddons: false,
      planCardProps: {
        cardGroup: true,
      },
    },
    comparison: {
      clientImg: '/images/employer/clientImg.webp',
      otherImg: '/images/employer/otherImg.webp',
    },
    howItWorksSection: {
      enable: true,
      variant: 3,
      heroImage: '/images/employer/how-it-works-employer.webp',
      primaryButtonProps: {
        variant: 'outlined',
        color: 'secondary',
      },
    },
  },
  checkoutSection: {
    intialfrequency: 'annual_billed_monthly',
  },
  findProviderSection: {
    heroProps: {
      secondaryButtonProps: {
        enable: true,
        variant: 'outlined',
        color: 'primary',
      },
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    tabLabel: {
      annual: 'Billed Annually',
      annual_billed_monthly: 'Billed Monthly',
    },
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  savingsSummary: {
    enableFooterbar: true,
    contactSection: 'contactDetails',
    moreSavingsButtonProps: {
      variant: 'contained',
      color: 'primary',
    },
  },
  faqSection: {
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    enable: false,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
